import { isExpiringSignedUrl, isPrivateProductMediaUrl } from "./providers/provider-publication-media";

/**
 * Marketplace template URL safety. Image attributes must be durable HTTPS
 * URLs with no credentials, control characters, or markup.
 */

const MARKUP_OR_QUOTES = /["'<>]/;

function hasForbiddenControlChars(input: string): boolean {
  for (let i = 0; i < input.length; i += 1) {
    const code = input.charCodeAt(i);
    if (code <= 0x1f || code === 0x7f) return true;
  }
  return false;
}

export function sanitizeMarketplaceImageUrl(raw: string): string {
  const original = String(raw ?? "");
  if (!original) return "";
  if (hasForbiddenControlChars(original) || MARKUP_OR_QUOTES.test(original)) return "";
  const input = original.trim();
  if (!input) return "";
  let parsed: URL;
  try {
    parsed = new URL(input);
  } catch {
    return "";
  }
  if (parsed.protocol !== "https:") return "";
  if (parsed.username || parsed.password) return "";
  if (!parsed.hostname) return "";
  return parsed.href;
}

/** Same contract as listing-template-render: sanitizer plus no signed/private URLs. */
export function sanitizeDurableMarketplaceImageUrl(raw: string): string {
  const href = sanitizeMarketplaceImageUrl(raw);
  if (!href) return "";
  if (isExpiringSignedUrl(href) || isPrivateProductMediaUrl(href)) return "";
  return href;
}
